import { render, staticRenderFns } from "./LISResultType.vue?vue&type=template&id=2fd07cd9&scoped=true"
import script from "./LISResultType.vue?vue&type=script&lang=js"
export * from "./LISResultType.vue?vue&type=script&lang=js"
import style0 from "./LISResultType.vue?vue&type=style&index=0&id=2fd07cd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd07cd9",
  null
  
)

export default component.exports